
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-4"></div>
        <div class="col-lg-4">
            <img src="assets/img/auri.png" width="100%">
            <input [(ngModel)]="input.username" class="form-control" placeholder="Celular o correo electronico" ><br>
            <input [(ngModel)]="input.password" class="form-control" type="password" placeholder="Password"><br>
            <button (click)="onLogin()" class="btn btn-success form-control fondoNaranja inputInicioSesion">Iniciar Sesión</button>
            <div *ngIf="errorMsg" class="alert alert-danger" role="alert">{{errorMsg}}</div>
            <br><br>
            <!-- <a href="obtener-contrasena"><p class="center">Obtener mi contraseña</p></a> -->
        </div>
        <div class="col-lg-4"></div>
    </div>
</div>

